import { TransactionDetailList } from '../../interfaces/transaction.interface';

// Projects each row down to the columns named in `listElements`, in that order.
export const reorderKeys = (data: TransactionDetailList): Array<Record<string, unknown>> =>
  data.value?.map((item) => {
    const orderedItem: Record<string, unknown> = {};
    data.listElements?.forEach((key) => {
      if (key in item) {
        orderedItem[key] = item[key];
      }
    });
    return orderedItem;
  });
